import React, { Component } from 'react';
import { Pricing } from './Pricing';
interface ScarcityProps {
  selectedPlan: 'pro' | 'elite';
  onSelectPlan: (plan: 'pro' | 'elite') => void;
}
export function Scarcity({
  selectedPlan,
  onSelectPlan
}: ScarcityProps) {
  return <section className="bg-white pt-8 sm:pt-20 pb-6 sm:pb-10" data-id="element-283">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 text-center mb-5 sm:mb-10" data-id="element-284">
        <div className="inline-flex items-center gap-1 sm:gap-2 px-2.5 py-1 sm:px-4 sm:py-1.5 rounded-full bg-red-50 text-red-700 font-semibold text-[10px] sm:text-sm mb-3 sm:mb-6 ring-1 ring-red-200" data-id="element-285">
          <span data-id="element-286">🔥</span> Última oportunidad
        </div>

        <h2 className="text-xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-4 sm:mb-8" data-id="element-287">
          No dejes que se acaben los cupos
        </h2>

        <div className="bg-slate-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 ring-1 ring-slate-200 mb-4 sm:mb-6" data-id="element-288">
          <div className="flex justify-between text-[10px] sm:text-sm font-medium text-slate-700 mb-1.5 sm:mb-2" data-id="element-289">
            <span data-id="element-290">Cupos restantes</span>
            <span className="text-red-600" data-id="element-291">68% TOMADOS</span>
          </div>
          <div className="w-full bg-slate-200 rounded-full h-1.5 sm:h-3 mb-2 sm:mb-4 overflow-hidden" data-id="element-292">
            <div className="bg-red-500 h-1.5 sm:h-3 rounded-full" style={{
            width: '68%'
          }} data-id="element-293"></div>
          </div>
          <p className="text-[10px] sm:text-sm text-slate-500" data-id="element-294">
            Cuando se acaben los cupos el precio sube y NO vuelve a bajar.
          </p>
        </div>
      </div>

      {/* Reuse Pricing Component but without the top padding and heading since we handle it here */}
      <div className="-mt-6 sm:-mt-16" data-id="element-295">
        <Pricing selectedPlan={selectedPlan} onSelectPlan={onSelectPlan} id="pricing-scarcity" data-id="element-296" />
      </div>
    </section>;
}